import { type ExamCenterProctorType } from '@exam-center/graphql';
import { type GridColDef, Text } from '@shared/components';

export interface AddProctorDetailsListItem {
  id: string;
  fullName: string;
  type: ExamCenterProctorType;
}

export const columns: GridColDef<AddProctorDetailsListItem>[] = [
  {
    field: 'name',
    headerName: 'ชื่อ-นามสกุล',
    sortable: false,
    disableColumnMenu: true,
    flex: 1,
    renderCell: ({ row }) => {
      return <Text>{row.fullName}</Text>;
    },
  },
  {
    field: 'type',
    headerName: 'ประเภทผู้คุมสอบ',
    disableColumnMenu: true,
    width: 240,
    sortable: false,
    renderCell: ({ row }) => {
      return <Text>{row.type}</Text>;
    },
  },
];
